var Prop = {};

//Prop.scadaServiceBaseUrl = "http://scada.dev.com:9014";
Prop.scadaServiceBaseUrl = "https://scada.senzmatica.com/api";
//Prop.scadaServiceBaseUrl = "https://scada.senzmate.com";

Prop.scadaUrl = "scada";